module.exports = __webpack_public_path__ + "img/50.e8afd921.png";